import React from "react";
import { AppCaregiver } from "../../../system/AppState/AppCaregiverState";
import { doNothing } from "../../../utils/doNothing";
import FinishOnboardingModal from "../../FinishOnboardingModal";
import { useFinishOnboardingModal } from "../../FinishOnboardingSection";

type Props = {
  caregiver: Pick<AppCaregiver, "firstName">;
  type: "regular" | "onboarding2";
  hideModal: boolean;
  onClick: () => void;
};

export default function FinishOnboardingModals(props: Props) {
  const { modalProps } = useFinishOnboardingModal({
    caregiver: props.caregiver,
    onClickNext: props.onClick,
    onRequestClose: props.type === "regular" ? props.onClick : doNothing,
  });

  switch (props.type) {
    case "regular":
      return (
        <FinishOnboardingModal {...modalProps} isOpen={!props.hideModal && modalProps.isOpen} />
      );
    case "onboarding2":
      return <FinishOnboardingModal.Stage2 {...modalProps} />;
  }
}
